import { HttpAdapter, addAction } from "js-data-http";
import { DataStore } from "js-data";
import clientRoutes from "./endPoints/clients";
import coachRoutes from "./endPoints/coaches";
import ownerRoutes from "./endPoints/owners";
import publicRoutes from "./endPoints/public";
import axios from "axios";

const options = {
  basePath: process.env.VUE_APP_API_URL,
  forceTrailingSlash: true,
  deserialize: (resourceName, res) => {
    let data = res.data;
    if (data && "count" in data && "next" in data && "results" in data) {
      data = data.results;
      data._meta = {
        count: res.data.count,
        next: res.data.next,
        previous: res.data.previous
      };
    }
    return data;
  }
};

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

const adapter = new HttpAdapter(options);
let store = new DataStore();
store.defineMapper("User", { endpoint: "user" });
// Sets version on every request
axios.defaults.headers = {
  "X-APP-VERSION": process.env.VUE_APP_VERSION,
  ...axios.defaults.headers
};
adapter.http.defaults.headers = {
  "X-APP-VERSION": process.env.VUE_APP_VERSION,
  ...adapter.http.defaults.headers
};

addAction("changePassword", {
  method: "POST",
  endpoint: "user",
  pathname: "set_password"
})(store.getMapper("User"));

addAction("resetPassword", {
  method: "POST",
  endpoint: "user",
  pathname: "reset_password"
})(store.getMapper("User"));

addAction("passwordChange", {
  method: "POST",
  pathname: "request_password_change",
  endpoint: "user"
})(store.getMapper("User"));

store.registerAdapter("http", adapter, { default: true });
store.cSave = (resource, instance) => {
  if (instance.id) {
    return store.update(resource, instance.id, instance);
  }
  return store.create(resource, instance);
};

[...ownerRoutes, ...coachRoutes, ...clientRoutes, ...publicRoutes].forEach(
  route => {
    store.defineMapper(route.name, { endpoint: route.endpoint });
  }
);
const cache = {};
store.detailRoute = function detailRoute(route, bypassCache=false) {
  if (!bypassCache && cache[route]) {
    return new Promise(resolve => {
      resolve(cache[route]);
    });
  }
  return axios.get(`${process.env.VUE_APP_API_URL}${route}`).then(({data}) => {
    cache[route] = data;
    return data;
  });
};

store.list = function list(route, query={}, bypassCache=false) {
  let cQ = JSON.stringify(query);
  if (!bypassCache && cache[route + cQ]) {
    return new Promise(resolve => {
      resolve(cache[route + cQ]);
    });
  }
  return axios.get(`${process.env.VUE_APP_API_URL}${route}`, {params: query})
    .then(({data}) => {
      cache[route + cQ] = data;
      return data;
    });
}

export default store;
export { adapter, axios };
